import { createActionGroup, props } from '@ngrx/store';
import { BaseJobFragment } from 'graphql.generated';

import { ActionSource } from '../../state/action-sources';

export const RightPanelComponentActions = createActionGroup({
  source: ActionSource.RIGHT_PANEL,
  events: {
    'Close Job Dialog Prompted': props<{ job: BaseJobFragment }>(),
    'Reopen Job Button Clicked': props<{ jobId: string }>(),
  },
});
